import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import Input from '@material-ui/core/Input';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { toast } from 'react-toastify';
import IconDeleteForeverFill from 'assets/Icons/IconDeleteForeverFill';
import IconEditFill from 'assets/Icons/IconEditFill';

import S from './TreeNode.styles';

const TreeNode = ({
  label,
  indent,
  children,
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  onChange = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  onDeleteNode = () => {},
  isEditDisabled,
}) => {
  const { t } = useTranslation();

  const [isExpanded, setIsExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [initialValue, setInitialValue] = useState(label);

  const [editableValue, setEditableValue] = useState(label);

  // eslint-disable-next-line consistent-return -- FIXME
  const handleChangeSubmit = () => {
    if (isEmpty(editableValue)) {
      return toast.error(t('$*treeNode.field.error.isEmpty'));
    }

    onChange(editableValue);
    setInitialValue(editableValue);
    setIsEditing(false);
  };

  const handleClickClear = () => {
    onChange(initialValue);
    setIsEditing(false);
  };

  return (
    <S.TreeNodeWrapper indent={indent}>
      <S.TreeNode>
        <div
          style={{ display: 'flex', 'align-items': 'center' }}
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
            !isEditing && setIsExpanded(prevState => !prevState);
          }}
        >
          {children && !!children[0] && !isEditing ? (
            <span>
              <KeyboardArrowDownIcon
                style={{
                  transform: isExpanded ? 'rotate(0)' : 'rotate(-90deg)',
                  transition: 'all 0.1s linear',
                }}
              />
            </span>
          ) : (
            <span>
              <KeyboardArrowDownIcon
                style={{
                  visibility: 'hidden',
                }}
              />
            </span>
          )}
          {isEditing ? (
            <Input
              value={editableValue}
              onChange={e => setEditableValue(e.target.value)}
            />
          ) : (
            <p>{label}</p>
          )}
        </div>
        <span>
          {isEditing && (
            <CheckIcon
              style={{ color: 'rgb(76, 175, 80)' }}
              onClick={handleChangeSubmit}
            />
          )}
          {!isEditing && !isEditDisabled && (
            <IconEditFill onClick={() => setIsEditing(true)} />
          )}
        </span>
        {isEditing && (
          <span onClick={handleClickClear}>
            <ClearIcon style={{ color: 'rgb(244, 67, 54)' }} />
          </span>
        )}
        {!isEditing && !isEditDisabled && (
          <span onClick={onDeleteNode}>
            <IconDeleteForeverFill />
          </span>
        )}
      </S.TreeNode>
      {isExpanded && children}
    </S.TreeNodeWrapper>
  );
};

export default TreeNode;
